import { takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import { GetDocumentActionTypes } from './types';
import { getDocumentActions } from './actions';
import DocumentService from '../../services/document.service';
import FileUtility from '../../blocks/utils/file-utility/FileUtility';
import { DocumentResponse } from '../../models/document/DocumentResponse';
import Toast from '../../components/shared/Toast';
import I18n from '../../blocks/localization';

export default function* documentSaga() {
    yield takeEvery(GetDocumentActionTypes.REQUEST, getDocumentRequest);
    yield takeEvery(GetDocumentActionTypes.SUCCESS, getDocumentSuccess);
    yield takeEvery(GetDocumentActionTypes.ERROR, getDocumentError);
}

function* getDocumentRequest(action: Action<string>) {
    yield sagaUtility(action.payload, DocumentService.getDocument, getDocumentActions.success, getDocumentActions.failure);
}

function* getDocumentSuccess(action: Action<DocumentResponse>) {
    FileUtility.downloadPdf({ content: action.payload.content, caption: action.payload.caption });
    yield;
}

function* getDocumentError(action: Action<any>) {
    Toast.notifyError(I18n.t('downloadDocumentError'));
    yield;
}
